<template>
    <div class="attribute-layout">
        <div v-for="(el, index) in filter(tree)" :key="index">
            <div class="control-group mb10">
                <span class="control-label"
                    ><Recommend v-if="recommend && !el.isCustom && el.recommendAttr" /><span
                        v-if="el.isNeeded == 'Y'"
                        class="red"
                        >*</span
                    ><template v-if="!el.isCustom">{{ el.name }}</template
                    ><template v-if="el.isCustom">
                        <el-input
                            v-model="el.name"
                            size="mini"
                            class="attrName"
                            style="width: 80px"
                            placeholder="属性名"
                            maxlength="10"
                            @change="addTxtNameInput(el)"
                        /> </template
                    >：</span
                >
                <div class="controls">
                    <template v-if="el.inputType == 0">
                        <!--输入框类型-->
                        <el-input
                            v-model="el.value"
                            size="mini"
                            clearable
                            style="width: 140px"
                            placeholder="请输入属性值"
                            @clear="txtInput(el)"
                            @change="txtInput(el)"
                            :maxlength="el.maxLength"
                        /><span class="ml5">{{ el.unit }}</span>
                        <el-button v-if="el.isCustom && isShowCustom" size="mini" type="text" @click="deleteAttr(el)"
                            >删除</el-button
                        >
                    </template>
                    <template v-else-if="el.inputType == 1">
                        <!--下拉框类型-->
                        <scrollSelect v-if="el.featureIdValues.length > 200" :el="el" @selectChanged="selectChanged" />
                        <el-select
                            v-else
                            v-model="el.vid"
                            clearable
                            style="width: 140px"
                            size="mini"
                            :filterable="el.featureIdValues.length > 10"
                            placeholder="请选择属性值"
                            @clear="selectChanged(el, $event)"
                            @change="selectChanged(el, $event)"
                        >
                            <el-option
                                v-for="(item, i) in el.featureIdValues"
                                :key="i"
                                :label="item.value"
                                :value="item.vid"
                            />
                        </el-select>
                        <el-input
                            v-if="el.vid == 20213"
                            v-model="el.value"
                            size="mini"
                            style="width: 100px"
                            class="ml5"
                            name=""
                            type="text"
                            @change="txtInput(el)"
                        />
                    </template>
                    <template v-else-if="el.inputType == 2">
                        <!--复选框类型-->
                        <el-popover placement="bottom" width="350" trigger="hover">
                            <el-button
                                slot="reference"
                                size="mini"
                                :title="el.vid.length ? el.value.join('、') : '修改'"
                                >{{ el.vid.length ? el.value.join('、') : '修改' }}</el-button
                            >
                            <el-checkbox-group v-model="el.vid">
                                <template v-for="(ele, index) in el.featureIdValues">
                                    <el-checkbox
                                        :key="index"
                                        :label="ele.vid"
                                        @change="
                                            (isChecked, e) => {
                                                checkboxChanged(el, isChecked, e);
                                            }
                                        "
                                        >{{ ele.vid == 20213 ? '其他' : ele.value }}
                                        <input
                                            v-if="el.vid.includes(20213) && ele.vid == 20213"
                                            class="checkboxTxtInput"
                                            :value="el.value | capitalize(el.vid)"
                                            @input="checkboxTxtInput(el, $event)"
                                            @change="checkboxTxtInput(el, $event)"
                                    /></el-checkbox>
                                </template>
                            </el-checkbox-group>
                        </el-popover>
                    </template>
                    <template v-else-if="el.inputType == 3">
                        <!--单选框类型 旧的-->
                        <!-- <el-radio-group
                            v-model="el.vid"
                            @change="radioChanged(el, $event)"
                        >
                            <el-radio
                                v-for="(ele, index) in el.featureIdValues"
                                :key="index"
                                :label="ele.vid"
                                >{{ ele.value }}</el-radio
                            >
                        </el-radio-group> -->
                        <!--下拉框类型 新的-->
                        <scrollSelect v-if="el.featureIdValues.length > 200" :el="el" @selectChanged="selectChanged" />
                        <el-select
                            v-else
                            v-model="el.vid"
                            clearable
                            style="width: 140px"
                            size="mini"
                            :filterable="el.featureIdValues.length > 10"
                            placeholder="请选择属性值"
                            @clear="selectChanged(el, $event)"
                            @change="selectChanged(el, $event)"
                        >
                            <el-option
                                v-for="(item, i) in el.featureIdValues"
                                :key="i"
                                :label="item.value"
                                :value="item.vid"
                            />
                        </el-select>
                        <el-input
                            v-if="el.vid == 20213"
                            v-model="el.value"
                            size="mini"
                            style="width: 100px"
                            class="ml5"
                            name=""
                            type="text"
                            @change="txtInput(el)"
                        />
                    </template>
                    <template v-else>
                        <!--复选框类型 旧的-->
                        <!-- <el-checkbox-group v-model="el.vid">
                            <el-checkbox
                                v-for="(ele, index) in el.featureIdValues"
                                :key="index"
                                :label="ele.vid"
                                @change="
                                    (isChecked, e) => {
                                        checkboxChanged(el, isChecked, e);
                                    }
                                "
                                >{{ ele.value }}</el-checkbox
                            >
                        </el-checkbox-group> -->
                        <!--复选框类型 新的-->
                        <el-popover placement="bottom" width="350" trigger="hover">
                            <el-button
                                slot="reference"
                                size="mini"
                                :title="el.vid.length ? el.value.join('、') : '修改'"
                                >{{ el.vid.length ? el.value.join('、') : '修改' }}</el-button
                            >
                            <el-checkbox-group v-model="el.vid">
                                <template v-for="(ele, index) in el.featureIdValues">
                                    <el-checkbox
                                        :key="index"
                                        :label="ele.vid"
                                        @change="
                                            (isChecked, e) => {
                                                checkboxChanged(el, isChecked, e);
                                            }
                                        "
                                        >{{ ele.vid == 20213 ? '其他' : ele.value }}
                                        <input
                                            v-if="el.vid.includes(20213) && ele.vid == 20213"
                                            class="checkboxTxtInput"
                                            :value="el.value | capitalize(el.vid)"
                                            @input="checkboxTxtInput(el, $event)"
                                            @change="checkboxTxtInput(el, $event)"
                                    /></el-checkbox>
                                </template>
                            </el-checkbox-group>
                        </el-popover>
                    </template>
                </div>
            </div>
            <template v-if="el.subtree.length > 0">
                <attributeLayout :tree="el.subtree" />
            </template>
        </div>
    </div>
</template>

<script>
import scrollSelect from './scrollSelect';
import Recommend from '../../recommend/Recommend.vue';
export default {
    name: 'AttributeLayout',
    components: { scrollSelect, Recommend },
    filters: {
        capitalize: function (value, vid) {
            const findIndex = vid.findIndex((item) => {
                return item == 20213;
            });
            return value[findIndex];
        },
    },
    props: {
        tree: Array,
        isShowCustom: {
            type: Boolean,
            default: false,
        },
        isShowCustomAttribute: {
            type: Boolean,
            default: false,
        },
        recommend: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {
        filter(tree) {
            return tree.filter((item) => {
                if (item == '') {
                    // 兼容旧数据
                    return false;
                }
                if (item.isCustom) {
                    if (this.isShowCustom || this.isShowCustomAttribute) {
                        return item;
                    }
                } else {
                    return item;
                }

                return false;
            });
        },
        deleteAttr(el) {
            // 删除自定义属性
            this.$parent.deleteAttr(el);
        },
        setValue(el) {
            this.$parent.setValue(el);
        },
        getSubtree(el) {
            this.$parent.getSubtree(el);
        },
        selectCallBack(el) {
            this.$parent.selectCallBack(el);
        },
        addTxtNameInput(el) {
            this.$parent.addTxtNameInput(el);
        },
        txtInput(el) {
            // 文本框事件
            this.$parent.setValue(el);
            this.$parent.getSubtree(el);
        },
        checkboxTxtInput(el, e) {
            const findIndex = el.vid.findIndex((item) => {
                return item == 20213;
            });
            const defaultValue = e.type == 'change' ? '其他' : '';
            el.value[findIndex] = e.target.value ? e.target.value : defaultValue;

            this.$parent.setValue(el);
            this.$parent.getSubtree(el);
        },
        selectChanged(el, vid) {
            // 下拉事件
            el.value = this.getVlaue(el, vid);
            this.$parent.selectCallBack(el);
            this.$parent.setValue(el);
            this.$parent.getSubtree(el);
        },
        checkboxChanged(el, isChecked, e) {
            // 复选框事件
            el.value = el.value == '' ? [] : el.value;
            el.vid = el.vid == '' ? [] : el.vid;
            const vid = e.target.value;
            let value = this.getVlaue(el, vid);
            if (isChecked) {
                el.value.push(value);
            } else {
                // 复选框
                if (
                    vid == 20213 &&
                    e.target.parentNode.parentNode.children[1].getElementsByClassName('checkboxTxtInput')[0].value
                ) {
                    value =
                        e.target.parentNode.parentNode.children[1].getElementsByClassName('checkboxTxtInput')[0].value;
                }

                const index = el.value.findIndex((item) => {
                    return item == value;
                });
                if (index > -1) {
                    el.value.splice(index, 1);
                }
            }
            this.$parent.setValue(el);
        },
        radioChanged(el, vid) {
            // 单选按钮事件
            el.value = this.getVlaue(el, vid);
            this.$parent.setValue(el);
            this.$parent.getSubtree(el);
        },
        getVlaue(el, vid) {
            let value = '';
            for (var i = 0; i < el.featureIdValues.length; i++) {
                if (el.featureIdValues[i].vid == vid) {
                    value = el.featureIdValues[i].value;
                    break;
                }
            }
            return value;
        },
    },
};
</script>
<style lang="scss" scoped>
.red {
    color: red;
}
.checkboxTxtInput {
    width: 100px;
    line-height: 28px;
    height: 28px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    font-size: 12px;
    padding: 0 5px;
    color: #606266;
    &:hover {
        border-color: #c0c4cc;
    }
}
.mb10 {
    margin-bottom: 10px;
}
.control-group {
    display: table;
}
.control-group .control-label {
    display: table-cell;
    vertical-align: middle;
    width: 110px;
    text-align: right;
    // line-height: 1.2;
    height: 28px;
}

.control-group .controls {
    display: inline-block;
    vertical-align: middle;
    /deep/ .el-checkbox-group {
        margin-top: 5px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .el-checkbox {
            min-width: 90px;
            margin-bottom: 8px;
        }
    }
}
.attrName input {
    padding: 0 5px;
}
</style>
